import React, { useCallback } from 'react';
import { Checkbox } from 'antd';
import { FormikValues, useField, useFormikContext } from 'formik';
import { CheckboxGroupProps, CheckboxChangeEvent } from 'antd/lib/checkbox';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { useFormikFormContext } from '../FormikFormContext';
import { IExtraInputProps, useInputProps } from '../hooks/useInputProps';

export interface CheckboxGroupInputProps<T extends FormikValues>
  extends Omit<CheckboxGroupProps, 'name'>,
    IExtraInputProps {
  name: keyof T & string;
}

/**
 * Campo per input di tipo gruppo di checkbox (checkbox multiple).
 */
export function CheckboxGroupInput<T extends FormikValues>(
  props: CheckboxGroupInputProps<T>
) {
  const { name, extraOptions, ...otherProps } = props;
  const [field, meta, helpers] = useField<string[]>(name);
  const handleChange = useCallback(
    (e: CheckboxValueType[]) => helpers.setValue(e as string[]),
    [name]
  );
  const inputProps = useInputProps(props);

  return (
    <Checkbox.Group
      {...otherProps}
      {...field}
      value={field.value}
      onChange={handleChange}
      {...inputProps}
    />
  );
}
